import {ValidationError} from "../errors/ValidationError";

const useValidator = () => errors => {
  return Object.keys(errors).length ? Promise.reject(new ValidationError(errors)) : Promise.resolve();
}

export default useValidator;
